const Constants = {
    comment: {
        entityTypes: {
            TYPE_CARD: 'card',
            TYPE_CARD_ELEMENT: 'card_element',
        }
    },

    user: {
        subordinates:{
            SUBORDINATES_NONE: null,
            SUBORDINATES_DIRECT: 1,
            SUBORDINATES_ALL: 2,
        }
    },

    stage:{
        types: {
            TYPE_PLAN: 'plan',
            TYPE_CORRECTION: 'correction',
            TYPE_INTERMEDIATE_ASSESSMENT: 'intermediate_assessment',
            TYPE_ASSESSMENT: 'assessment',
        }
    },

    group: {
        types: {
            TYPE_STATIC: 1,
            TYPE_DYNAMIC: 2,
        }
    },
    card: {
        statuses: {
            STATUS_COMPLETED: 200,
        }
    },

    library: {
        folderVisibilityConfigMode: {
            MODE_WHITELIST: 1,
            MODE_BLACKLIST: 2,
        },
        elementChangePropagationModes: {
            MODE_ALL_CARDS: 1,
            MODE_NOT_FINISHED_CARDS: 2,
        }
    },

    visualQueryBuilder: {
        formEntityTypes: {
            TYPE_REPORT: 'report',
            TYPE_LIBRARY_FOLDER: 'library_folder',
            TYPE_PREPROCESSOR_ITEM: 'preprocessor_item',

            TYPE_CASCADING_ELEMENT_CARD_ASSIGNMENTS: 'cascading_element_card_assignments',
            TYPE_CASCADING_ELEMENT_AUTO_CASCADING: 'cascading_element_auto_cascading',

            TYPE_EVAL_PROFILE_USERS: 'eval_profile_users',
            TYPE_EVAL_EVALUATION_USERS: 'eval_evaluation_users',

            TYPE_GROUP_USERS: 'group_users',
        }
    },

}

export default {
    install(Vue) {
        Vue.prototype.$constants = Constants;
    },

}

export { Constants }